import React, { PureComponent } from 'react'
import classNames from 'classnames'
import styled, { keyframes, css } from 'styled-components'

const sizes = {
  large: 27,
  normal: 18, // default
}

export default class Spinner extends PureComponent {
  static defaultProps = {
    size: 'normal',
    active: true,
    inline: false,
  }

  render() {
    const { active, className, style, size, inline } = this.props

    if (active) {
      return (
        <Container
          className={classNames(className, 'px-spinner')}
          style={style}
          size={sizes[size]}
          inline={inline}
        >
          <span />
        </Container>
      )
    } else {
      return null
    }
  }
}

const rotateAnimationKeyFrames = keyframes`
  to {
    transform: rotate(360deg);
  }
`
const rotateAnimation = css`
  ${rotateAnimationKeyFrames} 0.5s infinite linear;
`

const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  > span {
    display: block;
    width: ${(props) => props.size}px;
    height: ${(props) => props.size}px;

    position: relative;

    top: 50%;
    left: 50%;
    margin-top: -${(props) => props.size / 2}px;
    margin-left: -${(props) => props.size / 2}px;

    border: 2px solid rgba(0, 0, 0, 0.2);
    border-radius: 100%;

    &::after {
      content: '';
      display: inline-block;
      width: ${(props) => props.size}px;
      height: ${(props) => props.size}px;

      position: absolute;

      left: -2px;
      top: -2px;

      border: 2px solid rgba(0, 0, 0, 0.7);
      border-top-color: transparent;
      border-left-color: transparent;
      border-right-color: transparent;
      border-radius: 100%;

      animation: ${rotateAnimation};
    }
  }

  ${(props) =>
    props.inline &&
    `
    display: inline-block;
    width: 18px;
    height: 18px;
  `};
`
